import { z } from "zod";

export const EntregaObraClienteTermoSchema = z.object({
    idEntregaObraCliente: z.number().int().nullable().default(null),
    idsTermo: z.array(z.number().int().positive()),

});

export type EntregaObraClienteTermoForm = z.infer<typeof EntregaObraClienteTermoSchema>;

export const defaultEntregaObraClienteTermoForm: Partial<EntregaObraClienteTermoForm> = {
    idEntregaObraCliente: undefined,
    idsTermo: [],

};


